import { render } from "./HeaderBaluchonalzheimer.vue?vue&type=template&id=a2de5d32&scoped=true"
import script from "./HeaderBaluchonalzheimer.vue?vue&type=script&lang=js"
export * from "./HeaderBaluchonalzheimer.vue?vue&type=script&lang=js"

import "./HeaderBaluchonalzheimer.vue?vue&type=style&index=0&id=a2de5d32&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2de5d32"]])

export default __exports__